export default __webpack_public_path__ + "static/media/aries.f9915bb3.png";